module.exports = __webpack_public_path__ + "img/Icon-sidebar-vitamins.b74d1a2c.svg";